export default "/images/press2.png?237163205139ede0cc241b4887414a21";